import $ from 'jquery';
import vars from '../utility/vars';
import imageLoader from './image-loader';
import listitemlimit from './list-item-limit';

function calculateImageWidth(elem) {
    const maxWidth = elem.attr('max-width') || vars.screenMaxWidth;
    const fixedWidth = elem.attr('fw');
    const pixelDensity = vars.devicePixelRatio;
    let widthDesktopInPercent = elem.attr('wd');
    let widthTabletInPercent = elem.attr('wt');
    let widthMobileInPercent = elem.attr('wm');

    if (fixedWidth) {
        return fixedWidth;
    }

    widthDesktopInPercent = widthDesktopInPercent || widthTabletInPercent || widthMobileInPercent;
    widthTabletInPercent = widthTabletInPercent || widthDesktopInPercent;
    widthMobileInPercent = widthMobileInPercent || widthTabletInPercent || widthDesktopInPercent;

    let imageMaxWidth;
    let imageMaxHeight;

    // If desktop
    if (vars.screenWidth > vars.tabletThreshold) {
        imageMaxWidth = widthDesktopInPercent / 100 * vars.screenWidth;
        // If tablet
    } else if (vars.screenWidth > vars.mobileThreshold) {
        imageMaxWidth = widthTabletInPercent / 100 * vars.screenWidth;
        // If mobile
    } else {
        imageMaxWidth = widthMobileInPercent / 100 * vars.screenWidth;
    }

    // If desktop
    if (vars.screenHeight > vars.tabletThreshold) {
        imageMaxHeight = widthDesktopInPercent / 100 * vars.screenHeight;
        // If tablet
    } else if (vars.screenHeight > vars.mobileThreshold) {
        imageMaxHeight = widthTabletInPercent / 100 * vars.screenHeight;
        // If mobile
    } else {
        imageMaxHeight = widthMobileInPercent / 100 * vars.screenHeight;
    }

    // Width from percent in pixels
    const widthFromPercent = Math.max(imageMaxWidth, imageMaxHeight);

    // The lowest of width from pixels and the max width
    const bestWidth = Math.min(widthFromPercent, maxWidth);

    // Add pixel density to the calculation, but do not server larger than 1920 pictures
    const imgWidth = Math.ceil(Math.min(maxWidth, bestWidth * pixelDensity));

    // if we from the server allow larger images than the premade breakpoints, then serve that
    return imgWidth > maxWidth ? maxWidth : imgWidth;
}

function calculateImageExtension(elem) {
    const resizeParams = {};

    if (!elem.attr('wm') && !elem.attr('wt') && !elem.attr('wd') && !elem.attr('fw')) {


        // change: TH-imageload
        // on product page image, we only want images in the size closest to their parent containers width;
        // This should probably be move to an data-attr we could set in backend instead of a css class.
        if (elem.parents('.product-block-image').length > 0){
            resizeParams.width = imageLoader.getClosestSize(imageLoader.checkParentSize(elem));
            return $.param(resizeParams);
        }
        return '';
    }

    const bestWidthInRightDensity = calculateImageWidth(elem);


    const squared = elem.data('squared');
    const isSquared = !!squared && squared === 1;

    resizeParams.width = bestWidthInRightDensity;
    if (isSquared) {
        resizeParams.h = bestWidthInRightDensity;
    }

    if (!resizeParams.c) {
        delete resizeParams.c;
    }
    const extension = $.param(resizeParams);
    elem.data('calculated-extension', extension);
    return extension;
}

function addImageExtension(source, extension) {
    if (source.indexOf('?') !== -1) {
        return source + '&' + extension;
    }
    return source + '?' + extension;

}

function unveil(images, threshold, isBackgroundImages) {
    const $w = $(window);
    const th = threshold || 0;
    let loaded;

    if (isBackgroundImages) {
        // Handle background images
        images.one('unveil', function () {
            const source = this.getAttribute('data-bg');
            const elem = $(this);
            let extension;
            if (source) {
                if (!elem.data('calculated-extension')) {
                    extension = calculateImageExtension(elem);
                } else {
                    extension = elem.data('calculated-extension');
                }
                // LazyIcon class styles the lazy loading icon
                if (elem.hasClass('lazyIcon')) {
                    elem.removeClass('lazyIcon');
                }

                elem.css('backgroundImage', "url('" + addImageExtension(source, extension) + "')").animate({
                    'opacity': 1 // css
                }, 250);
                elem.removeClass('lazy');
            }
        });
    } else {
        // Handle regular images
        images.one('unveil', function () {
            const elem = $(this);
            let source = this.getAttribute('data-src');
            let extension;

            if (source) {
                if (!elem.data('calculated-extension')) {
                    extension = calculateImageExtension(elem);
                } else {
                    extension = elem.data('calculated-extension');
                }
                // LazyIcon class styles the lazy loading icon
                if (elem.hasClass('lazyIcon')) {
                    elem.removeClass('lazyIcon');
                }

                source = addImageExtension(source, extension);

                // fix http:for loacl ip
                const local = !source.indexOf('192.168');
                if (local){
                    source = 'http://' + source;
                    // source = "http://"+source.substr(source.indexOf('/'), source.length);
                }

                this.setAttribute('src', source);
                elem.one('load', function() {
                    elem.removeClass('lazy');
                    elem.addClass('lazyloaded');
                });
            }
        });
    }

    function unveilImage() {
        const inview = images.filter(function () {
            const $e = $(this);
            const wt = $w.scrollTop();
            const wb = wt + $w.height();
            const et = $e.offset().top;
            const eb = et + $e.height();

            // change: TH-imageload
            // dont unveil images that is hidden by the list-item-limit
            if ($e.parents('.' + listitemlimit.getLimitClass() ).length > 0 ){
                // console.log("dont load");
                return false;
            }

            return eb >= wt - th && et <= wb + th;
        });

        if (inview.length > 0) {
            loaded = inview.trigger('unveil');
            images = images.not(loaded); // eslint-disable-line no-param-reassign
        }
    }
    $w.scroll(unveilImage);
    $w.resize(unveilImage);
    $w.on('lazyload', unveilImage);

    unveilImage();
}

function init() {
    const imgs = $('img.lazy');
    const bgImages = $('[data-bg].lazy');

    if (vars.isMobileDevice) {
        // Begin loading images 200 px before in view on mobile
        unveil(imgs, 50, false);
        unveil(bgImages, 50, true);
    } else {
        unveil(imgs, 300, false);
        unveil(bgImages, 300, true);
    }
}

export default {
    init
};
